import React from 'react';

function Home() {
  return (
    <div className="page">
      <h2>Test App 2 – vibe-deploy is working!</h2>
      <p>Version 2 — changed for rollback test.</p>
    </div>
  );
}

export default Home;
